export enum DocumentationPreviewEnum {
  RowCard = 'rowCard',
  BlockCard = 'blockCard',
}
